const ErrorCodes = {
    access_denied: 'access_denied',
    already_confirmed: 'already_confirmed',
    auth_failed: 'auth_failed',
    internal_server_error: 'internal_server_error',
    invalid_param: 'invalid_param',
    invalid_token: 'invalid_token',
    phone_exists: 'phone_exists',
    phone_not_found: 'phone_not_found',
    too_many_attempts: 'too_many_attempts',
    rpc_communication_error: 'rpc_communication_error',
    failed_to_create_websocket: 'failed_to_create_websocket',
    err_network: 'ERR_NETWORK',
    email_not_found: 'email_not_found',
    duplicate: 'duplicate',
    other: 'other',
};

export default ErrorCodes;
